class CartRecommendations extends HTMLElement {

	#limit;
	#section;
	#intent;

	constructor(){
		super();
		this.#limit = this.dataset.limit;
		this.#section = this.dataset.section;
		this.#intent = this.dataset.intent || 'related';
		this.generateRecommendations();
	}

	// PEEKER 27.10.2026: najpierw produkty uzupelniajace (Search & Discovery), gdy brak — podobne (related)
	generateRecommendations(intent = this.#intent){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.#section}&product_id=${cartItems[0].dataset.productId}&limit=${this.#limit}&intent=${intent}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          } else if ( intent === 'complementary' ) {
          	this.generateRecommendations('related');
          }
				})
				.catch(e=>{
					console.warn(e);
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);
